import { useEffect, useRef, useState } from "react";

export function useWidth<E extends HTMLElement = HTMLElement>(): [
  React.RefObject<E | null>,
  number,
] {
  const ref = useRef<E | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (!ref.current) {
        return;
      }
      setWidth(ref.current.offsetWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setWidth]);

  return [ref, width];
}
